// C:\MonProjet\BBW_DELEGUER\preprod\babyworld-backoffice\babyworld-backoffice\src\pages\doctors\DoctorsPage\index.js

import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { 
  PlusOutlined, UploadOutlined, DownloadOutlined, 
  FolderViewOutlined, AuditOutlined, UserOutlined, 
  RocketOutlined, FileSearchOutlined, EnvironmentOutlined,
  EditOutlined, DeleteOutlined, StarFilled, ScheduleOutlined, CrownOutlined,
  WarningOutlined, CheckCircleOutlined, StopOutlined
} from "@ant-design/icons";
import { unwrapResult } from '@reduxjs/toolkit';
import { 
  Button, Card, Col, Row, Space, Table, Upload, Input, 
  Modal, Spin, Tag, Typography, Form, Select, List, Popconfirm,
  Collapse, Badge, Tooltip
} from "antd"; 
import Filter from "../../../components/filter/Filter";
import { useDispatch, useSelector } from "react-redux";
import ArchivedModal from "./ArchivedModal";
import {
  deletePerson,
  getPersonByType,
  exportPersons,
  updatePerson 
} from "../../../redux/slices/persons/personsThunk";
import { getSpecialtiesForFilter } from "../../../redux/slices/specialtys/specialtysThunk";
import { getGovernments } from "../../../redux/slices/governments/governmentsThunk";
import { getRegions } from "../../../redux/slices/regions/regionsThunk";
import { toast } from "react-toastify";
import { columns } from "./columns";
import { uploadDoctorFile } from "../../../redux/slices/importDoctors/importPersonsThunk";
import ImportComponent from "../../../components/logModal";
import CorrectionRequestsModal from "./CorrectionRequestsModal";
import axiosInstance from "../../../services/axiosServicesVisit";
import { getDelegatesList } from "../../../redux/slices/delegates/delegatesThunk";
import DoctorHistoryModal from "../../../components/DoctorHistoryModal";
import dayjs from "dayjs";


const { Text, Title } = Typography;

// --- CONFIGURATION DE LA SEGMENTATION RELATIONNELLE AVEC COULEURS DE LA MODALE ---
export const RELATIONSHIP_CONFIG = {
  PARTNER_ACTIVE: {
    label: "⭐ Partenaire Stratégique [B+]",
    tagColor: "gold",
    icon: <StarFilled />,
    rowClass: "row-partner-gold",
    bgColor: "#fffbe6",
    borderColor: "#fadb14",
    titleColor: "#856404",
    shadow: "0 4px 12px rgba(250, 219, 20, 0.18)"
  },
  PARTNER_AT_RISK: {
    label: "⚠️ Partenaire Sous Vigilance [A-]",
    tagColor: "warning",
    icon: <WarningOutlined />,
    rowClass: "row-partner-warning",
    bgColor: "#fff7e6",
    borderColor: "#fa8c16",
    titleColor: "#d46b08",
    shadow: "0 4px 12px rgba(250, 140, 22, 0.18)"
  },
  KEY_PRESCRIBER: {
    label: "🚀 Prescripteur [B]",
    tagColor: "success",
    icon: <RocketOutlined />,
    rowClass: "row-prescriber-green",
    bgColor: "#f6ffed",
    borderColor: "#52c41a",
    titleColor: "#237804",
    shadow: "0 4px 12px rgba(82, 196, 26, 0.18)"
  },
  STANDARD: {
    label: "👤 Standard [C]",
    tagColor: "default",
    icon: <UserOutlined />,
    rowClass: "",
    bgColor: "#f0f5ff",
    borderColor: "#adc6ff",
    titleColor: "#002766",
    shadow: "none"
  },
  REFRACTORY: {
    label: "⛔ Non Réceptif [C-]",
    tagColor: "error",
    icon: <StopOutlined />,
    rowClass: "row-refractory-red",
    bgColor: "#fff1f0",
    borderColor: "#ff4d4f",
    titleColor: "#cf1322",
    shadow: "0 4px 12px rgba(255, 77, 79, 0.18)"
  }
};

const DoctorsPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  
  const [commentForm] = Form.useForm();

  // --- DONNÉES REDUX ---
  const persons_data = useSelector((state) => state.persons.persons);
  const persons_loading = useSelector((state) => state.persons.loading);
  const governmentsData = useSelector((state) => state.governments.governments);
  const specialtysData = useSelector((state) => state.specialtys.specialtiesList);
  const regionsData = useSelector((state) => state.regions?.regions || []);
  const delegatesListData = useSelector((state) => state.delegates.delegatesList?.data?.data || []);

  // --- ÉTATS LOCAUX ---
  const [filter, setFilter] = useState({ 
    doctorType: "", 
    region: [], 
    specialty: [], 
    government: [], 
    assignmentStatus: "all", 
    relationshipCategory: "",
    isPartner: "" 
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [ids, setIds] = useState({ region: [], specialty: [], government: [] });
  const [pagination, setPagination] = useState({ currentPage: 1, pageSize: 10 });
  const [showLog, setShowLog] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [isArchiveModalVisible, setIsArchiveModalVisible] = useState(false);
  const [isCorrectionModalVisible, setIsCorrectionModalVisible] = useState(false);

  // --- ÉTATS ARCHIVAGE AVEC MOTIF ---
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemId, setCitemId] = useState(null);
  const [archiveReason, setArchiveReason] = useState("");
  const [customArchiveReason, setCustomArchiveReason] = useState("");
  const [archiveLoading, setArchiveLoading] = useState(false);

  // --- ÉTATS POUR LE COMMENTAIRE ADMIN ---
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [selectedPersonForComment, setSelectedPersonForComment] = useState(null);

  // --- ÉTATS POUR L'HISTORIQUE MÉDECIN ---
  const [doctorModalVisible, setDoctorModalVisible] = useState(false);
  const [selectedPersonId, setSelectedPersonId] = useState(null);

  const [isImportModalVisible, setIsImportModalVisible] = useState(false); 
  const [fileList, setFileList] = useState([]);

  // --- HANDLERS ---
  const handleShowLog = () => setShowLog(!showLog);
  const handlePageChange = (page, pageSize) => setPagination({ pageSize, currentPage: page });

  const getCategoryTagColor = (cat) => {
    if (!cat) return 'default';
    const c = String(cat).toUpperCase();
    if (c === 'AKTIV') return 'blue';
    if (c === 'SANOSAN') return 'green';
    if (c === 'MATERNITE') return 'purple';
    return 'cyan';
  };

  const showModal = (id) => { 
    setIsModalOpen(true); 
    setCitemId(id); 
    setArchiveReason("");
    setCustomArchiveReason("");
  };

  const createOptions = (data, labelKey = "name", idKey = "id") => {
    const list = Array.isArray(data) ? data : (data?.data || []);
    return list.map((item) => {
      let label = item[labelKey];
      if (item.firstname || item.lastname) {
        label = `${item.firstname || ''} ${item.lastname || ''}`.trim();
      }
      return { id: item[idKey], label: label || `ID: ${item[idKey]}`, value: item[idKey] };
    });
  };

  // FILTRES AVEC CIBLAGE MÉDECIN
  const optionsLists = [
    { 
      name: "Profil & Prescription", 
      placeholder: "Segment / Profil", 
      key: "relationshipCategory", 
      multiple: false, 
      options: [
        { label: "Tous les profils", value: "" }, 
        { label: "⭐ Partenaire Stratégique [B+]", value: "PARTNER_ACTIVE" }, 
        { label: "⚠️ Partenaire Sous Vigilance [A-]", value: "PARTNER_AT_RISK" }, 
        { label: "🚀 Prescripteur [B]", value: "KEY_PRESCRIBER" }, 
        { label: "👤 Standard [C]", value: "STANDARD" }, 
        { label: "⛔ Non Réceptif [C-]", value: "REFRACTORY" }
      ] 
    },
    { name: "Spécialités", placeholder: "Spécialités", key: "specialty", multiple: true, options: createOptions(specialtysData) },
    { name: "Gouvernorat", placeholder: "Gouvernorat", key: "government", multiple: true, options: createOptions(governmentsData?.data) },
    { name: "Région", placeholder: "Région", key: "region", multiple: true, options: createOptions(regionsData?.data || regionsData) },
    { name: "Délégués", placeholder: "Délégués assignés", key: "delegates", multiple: true, options: createOptions(delegatesListData) },
    { name: "Assignation", placeholder: "Statut", key: "assignmentStatus", multiple: false, options: [{ label: "Tous", value: "all" }, { label: "Assigné", value: "assigned" }, { label: "Non assigné", value: "unassigned" }] },
    { 
      name: "Type Médecin", 
      placeholder: "Type (Privé/Hosp)", 
      key: "doctorType", 
      multiple: false, 
      options: [
        { label: "Tous", value: "" }, 
        { label: "Hospitalier", value: 1 }, 
        { label: "Privé", value: 2 }
      ] 
    }
  ];

  useEffect(() => {
    dispatch(getGovernments({ page: 1, limit: 100 }));
    dispatch(getSpecialtiesForFilter());
    dispatch(getRegions({ page: 1, itemsPerPage: 1000 }));
    dispatch(getDelegatesList({ page: 1, itemsPerPage: 1000 })); 
  }, [dispatch]);

  const refreshDoctorsList = useCallback(() => {
    dispatch(getPersonByType({
      type: 1,
      pageNumber: pagination.currentPage,
      limit: pagination.pageSize,
      filter: { ...filter, ...ids, search: searchTerm },
    }));
  }, [dispatch, pagination, filter, ids, searchTerm]);
  
  useEffect(() => { refreshDoctorsList(); }, [refreshDoctorsList]);

  // MISE À JOUR DU STATUT RELATIONNEL DU MÉDECIN
  const handleChangeDoctorRelationship = (record, newCategory) => {
    const isPartnerFlag = (newCategory === 'PARTNER_ACTIVE' || newCategory === 'PARTNER_AT_RISK');
    dispatch(updatePerson({
      personId: record.id,
      personData: { 
        relationshipCategory: newCategory,
        isPartner: isPartnerFlag
      }
    })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success(`Profil mis à jour : ${RELATIONSHIP_CONFIG[newCategory]?.label || newCategory}`);
        refreshDoctorsList();
      } else {
        toast.error("Erreur lors de la mise à jour du profil");
      }
    });
  };

  // SAUVEGARDE DU COMMENTAIRE ADMINISTRATIF
  const handleSaveComment = (values) => {
    const newEntry = `${dayjs().format('DD/MM/YYYY')} [${values.commercial}] : ${values.note}`;
    const existingComments = selectedPersonForComment.adminComment || "";
    const finalComment = existingComments 
      ? `${newEntry}\n${existingComments}` 
      : newEntry;
    
    dispatch(updatePerson({
      personId: selectedPersonForComment.id,
      personData: { adminComment: finalComment }
    })).then(() => {
      toast.success("Commentaire ajouté à l'historique");
      setIsCommentModalOpen(false);
      commentForm.resetFields();
      refreshDoctorsList();
    });
  };

  const handleDeleteCommentEntry = (record, indexToDelete) => {
    const currentEntries = record.adminComment.split('\n').filter(Boolean);
    const updatedEntries = currentEntries.filter((_, i) => i !== indexToDelete);
    const newCommentString = updatedEntries.length > 0 ? updatedEntries.join('\n') : null;

    dispatch(updatePerson({
      personId: record.id,
      personData: { adminComment: newCommentString }
    })).then(() => {
      toast.success("Entrée supprimée");
      refreshDoctorsList();
    });
  };

  // ⚡ RÉCUPÉRATION COMPLÈTE DE L'HISTORIQUE ET DU STATUT RÉEL DU MÉDECIN ⚡
  
const handleOpenDoctorHistory = (personId) => {
    setSelectedPersonId(personId);
    setDoctorModalVisible(true);
  };
  

  const handleExport = () => {
    setExporting(true);
    dispatch(exportPersons({ 
      type: 1, 
      format: 'csv', 
      filter: { ...filter, ...ids, search: searchTerm } 
    }))
    .unwrap()
    .catch((err) => toast.error("Erreur lors de l'export : " + err))
    .finally(() => setExporting(false));
  };

  const handleUploadCSV = () => {
    if (fileList.length === 0) return toast.error("Veuillez sélectionner un fichier.");
    const formData = new FormData();
    formData.append('file', fileList[0].originFileObj || fileList[0]);
    setIsImportModalVisible(false);
    setShowLog(true);
    dispatch(uploadDoctorFile(formData))
      .then(unwrapResult)
      .then(() => {
        setShowLog(false);
        toast.success("Importation terminée !");
        setFileList([]);
        refreshDoctorsList();
      })
      .catch((err) => {
        setShowLog(false);
        toast.error("Erreur d'importation : " + err);
      });
  };

  const handelDelete = () => {
    if (!archiveReason) {
      toast.warning("Veuillez sélectionner un motif d'archivage.");
      return;
    }

    const finalReason = archiveReason === "Autre" 
      ? (customArchiveReason.trim() ? `Autre: ${customArchiveReason.trim()}` : "Autre motif") 
      : archiveReason;

    setArchiveLoading(true);
    dispatch(deletePerson({ id: itemId, reason: finalReason })).then((result) => {
      setArchiveLoading(false);
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Médecin archivé avec succès");
        setIsModalOpen(false);
        refreshDoctorsList();
      } else {
        toast.error("Erreur lors de l'archivage");
      }
    });
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card bordered={false} className="criclebox tablespace mb-24" title="Liste des médecins" extra={
              <Space>
                <Button icon={<DownloadOutlined />} onClick={handleExport} loading={exporting}>Exporter</Button>
                <Button type="primary" icon={<UploadOutlined />} onClick={() => setIsImportModalVisible(true)}>Importer</Button>
                <Button icon={<AuditOutlined />} onClick={() => setIsCorrectionModalVisible(true)} style={{ color: '#faad14' }}>Suggestions</Button>
                <Button icon={<FolderViewOutlined />} onClick={() => setIsArchiveModalVisible(true)}>Archives</Button>
                <Button type="primary" onClick={() => history.push("/nouveau/médecin")} icon={<PlusOutlined />}>Ajouter</Button>
              </Space>
            }
          />
          <Card bordered={false} className="criclebox tablespace mb-24">
            <div style={{ padding: "0 24px 24px" }}>
              <Space direction="vertical" style={{ width: '100%' }}>
                  <Input.Search placeholder="Rechercher..." onSearch={val => setSearchTerm(val)} onChange={e => setSearchTerm(e.target.value)} allowClear value={searchTerm} />
                  <Filter optionsLists={optionsLists} onSelect={(val, key, id) => {
                      setFilter(prev => ({ ...prev, [key]: val }));
                      if(id) setIds(prev => ({ ...prev, [key]: id }));
                      setPagination(prev => ({ ...prev, currentPage: 1 }));
                  }} data={filter} />
              </Space>
            </div>
            <Table
              columns={columns(p => history.push(p), showModal, handleOpenDoctorHistory)}
              dataSource={persons_data?.data}
              loading={persons_loading}
              rowKey="id"
              rowClassName={(record) => {
                const cat = record.relationshipCategory;
                if (cat === 'REFRACTORY') return 'row-refractory-red';
                if (cat === 'PARTNER_AT_RISK') return 'row-partner-warning';
                if (cat === 'KEY_PRESCRIBER') return 'row-prescriber-green';
                if (cat === 'PARTNER_ACTIVE' || record.isPartner === true || record.isPartner === 'true' || record.isPartner === 1) {
                  return 'row-partner-gold';
                }
                return '';
              }}
              pagination={{ current: pagination.currentPage, total: persons_data?.total, onChange: handlePageChange }}
              scroll={{ x: 2000 }} 
              expandable={{
              expandedRowRender: (record) => {
                const effectiveCategory = record.relationshipCategory || (record.isPartner ? 'PARTNER_ACTIVE' : 'STANDARD');
                const config = RELATIONSHIP_CONFIG[effectiveCategory] || RELATIONSHIP_CONFIG.STANDARD;

                return (
                  <div style={{ margin: 0, padding: '15px 50px', background: '#f0f5ff', borderRadius: '4px' }}>
                    <Row gutter={24}>
                      <Col span={18}>
                        {/* 1. SECTION CODE & STATUT RELATIONNEL */}
                        <div style={{ marginBottom: '14px', display: 'flex', alignItems: 'center', gap: 16 }}>
                          <div>
                            <Text strong>Code : </Text>
                            <Tag color="cyan" style={{ fontSize: '13px', fontWeight: 'bold' }}>{record.code || 'Non généré'}</Tag>
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Text strong>Profil & Prescription :</Text>
                            <Select
                              size="small"
                              value={effectiveCategory}
                              style={{ width: 230 }}
                              onChange={(val) => handleChangeDoctorRelationship(record, val)}
                              options={[
                                { value: "PARTNER_ACTIVE", label: "⭐ Partenaire Stratégique" },
                                { value: "PARTNER_AT_RISK", label: "⚠️ Partenaire Sous Vigilance" },
                                { value: "KEY_PRESCRIBER", label: "🚀 Prescripteur Clé (A+)" },
                                { value: "STANDARD", label: "👤 Standard" },
                                { value: "REFRACTORY", label: "⛔ Non Réceptif" }
                              ]}
                            />
                            <Tag color={config.tagColor} icon={config.icon} style={{ fontWeight: 'bold' }}>
                              {config.label}
                            </Tag>
                          </div>
                        </div>

                        {/* 2. SECTION HISTORIQUE DE SUIVI (COMMERCIAUX) */}
                        <div style={{ marginBottom: '16px' }}>
                          <Text strong style={{ color: '#1890ff', display: 'block', marginBottom: '8px' }}>
                            Historique de suivi :
                          </Text>
                          {record.adminComment ? (
                            <List
                              size="small"
                              bordered
                              style={{ background: '#fff', borderRadius: '4px' }}
                              dataSource={record.adminComment.split('\n').filter(Boolean)}
                              renderItem={(item, index) => (
                                <List.Item
                                  style={{ fontSize: '13px' }}
                                  actions={[
                                    <Popconfirm
                                      title="Supprimer cette note ?"
                                      onConfirm={() => handleDeleteCommentEntry(record, index)}
                                      okText="Oui"
                                      cancelText="Non"
                                    >
                                      <DeleteOutlined style={{ color: '#ff4d4f', cursor: 'pointer' }} />
                                    </Popconfirm>
                                  ]}
                                >
                                  {item}
                                </List.Item>
                              )}
                            />
                          ) : (
                            <Text type="secondary" italic style={{ fontSize: '12px' }}>
                              Aucun commentaire administratif pour ce médecin.
                            </Text>
                          )}
                        </div>

                        {/* --- BLOC ACCORDÉON : CYCLES ET SEMAINES DE PLANIFICATION --- */}
                        <div style={{ marginBottom: '16px' }}>
                          <Collapse
                            ghost
                            style={{ 
                              background: '#ffffff', 
                              borderRadius: '6px', 
                              border: '1px solid #d6e4ff' 
                            }}
                            items={[
                              {
                                key: 'cycles_plan',
                                label: (
                                  <Space>
                                    <ScheduleOutlined style={{ color: '#0e519b', fontSize: '15px' }} />
                                    <Text strong style={{ color: '#0e519b' }}>
                                      Cycles et Semaines de planification
                                    </Text>
                                    <Badge 
                                      count={record.assignedCycles?.length || 0} 
                                      style={{ 
                                        backgroundColor: record.assignedCycles?.length > 0 ? '#1890ff' : '#d9d9d9',
                                        marginLeft: 6 
                                      }} 
                                    />
                                  </Space>
                                ),
                                children: (
                                  <div>
                                    {record.assignedCycles && record.assignedCycles.length > 0 ? (
                                      <Space wrap size={[8, 8]}>
                                        {record.assignedCycles.map((c, i) => (
                                          <Tag 
                                            key={i} 
                                            color="geekblue" 
                                            style={{ 
                                              padding: '4px 10px', 
                                              borderRadius: '4px',
                                              fontSize: '12px'
                                            }}
                                          >
                                            <b>{c.cycleName}</b> - <span style={{ color: '#1890ff', fontWeight: 600 }}>Semaine {c.weekNumber}</span>{' '}
                                            <span style={{ color: '#595959', fontSize: '11px' }}>
                                              ({dayjs(c.startDate).format('DD/MM/YY')} au {dayjs(c.endDate).format('DD/MM/YY')})
                                            </span>
                                            {c.delegateName && (
                                              <Tag color="purple" style={{ marginLeft: 6, fontSize: '10px' }}>
                                                {c.delegateName}
                                              </Tag>
                                            )}
                                          </Tag>
                                        ))}
                                      </Space>
                                    ) : (
                                      <Text type="secondary" italic style={{ fontSize: '12px' }}>
                                        Ce médecin n'est planifié dans aucun cycle actuellement.
                                      </Text>
                                    )}
                                  </div>
                                )
                              }
                            ]}
                          />
                        </div>

                        {/* 3. SECTION : HISTORIQUE PARTENARIAT / CONGRÈS */}
                        {(record.isPartner || effectiveCategory === 'PARTNER_ACTIVE' || effectiveCategory === 'PARTNER_AT_RISK') && (
                          <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px dashed #ffe58f' }}>
                            <Text strong style={{ color: effectiveCategory === 'PARTNER_AT_RISK' ? '#d4380d' : '#d4b106', display: 'block', marginBottom: '8px' }}>
                              <StarFilled /> Historique Partenaire & Voyages :
                            </Text>
                            {record.partnerNotes ? (
                              <List
                                size="small"
                                bordered
                                style={{ 
                                  background: effectiveCategory === 'PARTNER_AT_RISK' ? '#fff2e8' : '#fffbe6', 
                                  borderRadius: '4px', 
                                  border: effectiveCategory === 'PARTNER_AT_RISK' ? '1px solid #ffbb96' : '1px solid #ffe58f' 
                                }}
                                dataSource={record.partnerNotes.split('\n').filter(Boolean)}
                                renderItem={(item) => (
                                  <List.Item style={{ fontSize: '13px', color: effectiveCategory === 'PARTNER_AT_RISK' ? '#d4380d' : '#856404' }}>
                                    {item}
                                  </List.Item>
                                )}
                              />
                            ) : (
                              <Text type="secondary" italic style={{ fontSize: '12px' }}>
                                Aucune note partenaire enregistrée pour ce médecin.
                              </Text>
                            )}
                          </div>
                        )}
                      </Col>

                      <Col span={6} style={{ textAlign: 'right' }}>
                        <Button 
                          size="small" 
                          type="primary"
                          ghost
                          icon={<EditOutlined />} 
                          onClick={() => {
                            setSelectedPersonForComment(record);
                            setIsCommentModalOpen(true);
                          }}
                        >
                          Ajouter une note de suivi
                        </Button>
                      </Col>
                    </Row>
                  </div>
                );
              },
              rowExpandable: () => true,
            }}
            />

            {/* STYLES DES LIGNES EN FONCTION DE LA SEGMENTATION */}
            <style>{`
              .row-partner-gold td { background-color: #fffbe6 !important; }
              .row-partner-gold:hover td { background-color: #fff1b8 !important; }
              .row-partner-gold a { color: #856404 !important; }

              .row-partner-warning td { background-color: #fff7e6 !important; }
              .row-partner-warning:hover td { background-color: #ffe7ba !important; }
              .row-partner-warning a { color: #d46b08 !important; }

              .row-prescriber-green td { background-color: #f6ffed !important; }
              .row-prescriber-green:hover td { background-color: #d9f7be !important; }
              .row-prescriber-green a { color: #389e0d !important; }

              .row-refractory-red td { background-color: #fff1f0 !important; }
              .row-refractory-red:hover td { background-color: #ffccc7 !important; }
              .row-refractory-red a { color: #cf1322 !important; }
            `}</style>
          </Card>
        </Col>

       <DoctorHistoryModal
  visible={doctorModalVisible}
  onClose={() => setDoctorModalVisible(false)}
  personId={selectedPersonId}
/>

        {/* MODALE COMMENTAIRE ADMINISTRATIF */}
        <Modal
          title="Note Administrative / Commerciale"
          open={isCommentModalOpen}
          onCancel={() => setIsCommentModalOpen(false)}
          onOk={() => commentForm.submit()}
          okText="Enregistrer la note"
          cancelText="Annuler"
          destroyOnClose
        >
          <Form form={commentForm} layout="vertical" onFinish={handleSaveComment}>
            <Form.Item name="commercial" label="Commercial" rules={[{ required: true, message: 'Veuillez choisir un commercial' }]}>
              <Select placeholder="Choisir un trigramme">
                <Select.Option value="AN">AN</Select.Option>
                <Select.Option value="CHA">CHA</Select.Option>
                <Select.Option value="IBT">IBT</Select.Option>
                <Select.Option value="WCH">WCH</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name="note" label="Commentaire" rules={[{ required: true, message: 'Veuillez saisir un texte' }]}>
              <Input.TextArea rows={4} placeholder="Saisir les détails importants ici..." />
            </Form.Item>
          </Form>
        </Modal>

        {/* MODALE D'ARCHIVAGE AVEC MOTIF */}
        <Modal
          title={
            <Space>
              <WarningOutlined style={{ color: '#faad14', fontSize: '18px' }} />
              <span style={{ fontWeight: 'bold' }}>Archiver le médecin</span>
            </Space>
          }
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          onOk={handelDelete}
          okText="Confirmer l'archivage"
          okButtonProps={{ danger: true, loading: archiveLoading }}
          cancelText="Annuler"
          destroyOnClose
        >
          <div style={{ marginBottom: 16 }}>
            <Text>Voulez-vous vraiment archiver ce médecin ? Il ne sera plus visible dans la liste active.</Text>
          </div>

          <div style={{ marginBottom: 14 }}>
            <Text strong style={{ display: 'block', marginBottom: 6 }}>
              Motif de l'archivage <span style={{ color: 'red' }}>*</span> :
            </Text>
            <Select
              placeholder="Sélectionnez une raison..."
              style={{ width: '100%' }}
              value={archiveReason || undefined}
              onChange={(value) => setArchiveReason(value)}
              options={[
                { value: "Cessation d'activité / Retraite", label: "Cessation d'activité / Retraite" },
                { value: "Changement d'adresse / Hors secteur", label: "Changement d'adresse / Hors secteur" },
                { value: "Refus de visite / Non réceptif", label: "Refus de visite / Non réceptif" },
                { value: "Doublon / Erreur de saisie", label: "Doublon / Erreur de saisie" },
                { value: "Décès", label: "Décès" },
                { value: "Autre", label: "Autre motif" },
              ]}
            />
          </div>

          {archiveReason === "Autre" && (
            <div>
              <Text strong style={{ display: 'block', marginBottom: 6 }}>Précisez le motif :</Text>
              <Input.TextArea
                rows={2}
                placeholder="Indiquez les détails..."
                value={customArchiveReason}
                onChange={(e) => setCustomArchiveReason(e.target.value)}
              />
            </div>
          )}
        </Modal>

        <ImportComponent visible={showLog} onCancel={handleShowLog} />
        <ArchivedModal visible={isArchiveModalVisible} onClose={() => setIsArchiveModalVisible(false)} onRestoreSuccess={refreshDoctorsList} />
        <CorrectionRequestsModal visible={isCorrectionModalVisible} onClose={() => setIsCorrectionModalVisible(false)} />
        
        <Modal title="Importer la liste" open={isImportModalVisible} onOk={handleUploadCSV} onCancel={() => setIsImportModalVisible(false)} okText="Lancer" cancelText="Annuler">
          <Upload.Dragger accept=".csv" multiple={false} fileList={fileList} beforeUpload={(file) => { setFileList([file]); return false; }} onRemove={() => setFileList([])}>
            <p className="ant-upload-drag-icon"><FileSearchOutlined /></p>
            <p className="ant-upload-text">Cliquez ou glissez le fichier CSV ici</p>
          </Upload.Dragger>
        </Modal>
      </Row>
    </div>
  );
};

export default DoctorsPage;